import React, { useEffect } from 'react';

export default function TermsOfService() {
  useEffect(() => {
    document.title = 'Terms of Service | Bay Area Podcast Studio';
    let meta = document.querySelector('meta[name="robots"][data-legal]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'robots');
      meta.setAttribute('data-legal', 'true');
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', 'noindex, follow');
    return () => {
      document.title = 'Bay Area Podcast Studio';
      if (meta && meta.parentNode) meta.parentNode.removeChild(meta);
    };
  }, []);

  return (
    <main className="pt-[72px] min-h-screen bg-[#FFFFFF]">
      <div className="max-w-4xl mx-auto px-6 py-16 md:py-24 text-[#000000]">
        <h1 className="text-3xl md:text-5xl font-black mb-8 tracking-tight uppercase">Terms of Service</h1>
        
        <div className="space-y-6 text-sm md:text-base leading-relaxed font-medium">
          <p>
            These Terms of Service govern your use of the website located at https://www.bayareapodcast.studio and any related services provided by Bay Area Podcast Studio.
          </p>
          <p>
            By accessing https://www.bayareapodcast.studio, you agree to abide by these Terms of Service and to comply with all applicable laws and regulations. If you do not agree with these Terms of Service, you are prohibited from using or accessing this website or using any other services provided by Bay Area Podcast Studio.
          </p>
          <p>
            We, Bay Area Podcast Studio, reserve the right to review and amend any of these Terms of Service at our sole discretion. Upon doing so, we will update this page. Any changes to these Terms of Service will take effect immediately from the date of publication.
          </p>
          <p>
            These Terms of Service were last updated on July 1, 2026.
          </p>

          <h2 className="text-xl md:text-2xl font-black mt-12 mb-4 uppercase tracking-tight">Limitations of Use</h2>
          <p>
            By using this website, you warrant on behalf of yourself, your users, and other parties you represent that you will not:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>modify, copy, prepare derivative works of, decompile, or reverse engineer any materials and software contained on this website;</li>
            <li>remove any copyright or other proprietary notations from any materials and software on this website;</li>
            <li>transfer the materials to another person or "mirror" the materials on any other server;</li>
            <li>knowingly or negligently use this website or any of its associated services in a way that abuses or disrupts our networks or any other service Bay Area Podcast Studio provides;</li>
            <li>use this website or its associated services to transmit or publish any harassing, indecent, obscene, fraudulent, or unlawful material;</li>
            <li>use this website or its associated services in violation of any applicable laws or regulations;</li>
            <li>use this website in conjunction with sending unauthorized advertising or spam;</li>
            <li>harvest, collect, or gather user data without the user's consent; or</li>
            <li>use this website or its associated services in such a way that may infringe the privacy, intellectual property rights, or other rights of third parties.</li>
          </ul>

          <h2 className="text-xl md:text-2xl font-black mt-12 mb-4 uppercase tracking-tight">Intellectual Property</h2>
          <p>
            The intellectual property in the materials contained in this website are owned by or licensed to Bay Area Podcast Studio and are protected by applicable copyright and trademark law. We grant our users permission to download one copy of the materials for personal, non-commercial transitory use.
          </p>
          <p>
            This constitutes the grant of a license, not a transfer of title. This license shall automatically terminate if you violate any of these restrictions or the Terms of Service, and may be terminated by Bay Area Podcast Studio at any time.
          </p>

          <h2 className="text-xl md:text-2xl font-black mt-12 mb-4 uppercase tracking-tight">Liability</h2>
          <p>
            Our website and the materials on our website are provided on an 'as is' basis. To the extent permitted by law, Bay Area Podcast Studio makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property, or other violation of rights.
          </p>
          <p>
            In no event shall Bay Area Podcast Studio or its suppliers be liable for any consequential loss suffered or incurred by you or any third party arising from the use or inability to use this website or the materials on this website, even if Bay Area Podcast Studio or an authorized representative has been notified, orally or in writing, of the possibility of such damage.
          </p>
          <p>
            In the context of this agreement, "consequential loss" includes any consequential loss, indirect loss, real or anticipated loss of profit, loss of benefit, loss of revenue, loss of business, loss of goodwill, loss of opportunity, loss of savings, loss of reputation, loss of use and/or loss or corruption of data, whether under statute, contract, equity, tort (including negligence), indemnity or otherwise.
          </p>
          <p>
            Because some jurisdictions do not allow limitations on implied warranties, or limitations of liability for consequential or incidental damages, these limitations may not apply to you.
          </p>

          <h2 className="text-xl md:text-2xl font-black mt-12 mb-4 uppercase tracking-tight">Accuracy of Materials</h2>
          <p>
            The materials appearing on our website are not comprehensive and are for general information purposes only. Bay Area Podcast Studio does not warrant or make any representations concerning the accuracy, likely results, or reliability of the use of the materials on this website, or otherwise relating to such materials or on any resources linked to this website.
          </p>

          <h2 className="text-xl md:text-2xl font-black mt-12 mb-4 uppercase tracking-tight">Links</h2>
          <p>
            Bay Area Podcast Studio has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement, approval or control by Bay Area Podcast Studio of the site. Use of any such linked site is at your own risk and we strongly advise you make your own investigations with respect to the suitability of those sites.
          </p>

          <h2 className="text-xl md:text-2xl font-black mt-12 mb-4 uppercase tracking-tight">Right to Terminate</h2>
          <p>
            We may suspend or terminate your right to use our website and terminate these Terms of Service immediately upon written notice to you for any breach of these Terms of Service.
          </p>

          <h2 className="text-xl md:text-2xl font-black mt-12 mb-4 uppercase tracking-tight">Severance</h2>
          <p>
            Any term of these Terms of Service which is wholly or partially void or unenforceable is severed to the extent that it is void or unenforceable. The validity of the remainder of these Terms of Service is not affected.
          </p>

          <h2 className="text-xl md:text-2xl font-black mt-12 mb-4 uppercase tracking-tight">Governing Law</h2>
          <p>
            These Terms of Service are governed by and construed in accordance with the laws of California. You irrevocably submit to the exclusive jurisdiction of the courts in that State or location.
          </p>
        </div>
      </div>
    </main>
  );
}